<template>
    <div class="thankyouPage">
        <h5>
            Thank you for reaching out
        </h5>

        <div>
            A Community Savings team member will be in touch soon.
            <br />
            Explore what <a href="https://www.comsavings.com">Community Savings Credit Union</a> has to offer.
        </div>
        
        <img id="mailPhoneImg" src="@/assets/images/MailPhone.svg" alt="mailPhoneImg">
    </div>
</template>